import { Box } from "@mui/material";

const Footer = () => {
    return (
        <Box
            sx={{
                width: "100%",
                mt: 5,
                py: 3,
                backgroundColor: "#0f0f0fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                fontSize: "0.9rem"
            }}
        >
            <p>© 2025 Contblack. Todos os direitos reservados.</p>
        </Box>
    );
}

export default Footer;